<template>
    <div class="p-4 border border-gray text-center h-full flex flex-col rounded relative overflow-hidden">
        <ribbon v-if="product.hot_buy">Hot Buy</ribbon>
        <ribbon v-if="product.local" position="top_left">Local</ribbon>
        <div class="h-40 flex items-center justify-center product-image relative">
            <div class="overlay cursor-pointer"  @click="handleQuickview(product)">Click to view</div>

            <img v-if="product.image != null" 
                :src="'/storage/' + product.image" 
                class="mx-auto max-h-40" 
                alt="Product Image" 
                loading="lazy"
            />
            <img v-show="product.image == null" 
                src="/images/product-placeholder.png" 
                class="mx-auto max-h-40" 
                alt="No Image" 
                loading="lazy"
            />
        </div>

        <div class="flex-1">
            <h2
                class="leading-tight mt-3 mb-1 text-base md:text-lg md:leading-tight font-bold overflow-hidden cursor-pointer"
                @click="handleQuickview(product)"
            >
                {{ product.title }}
            </h2>
            <p class="leading-tight text-sm">{{ product.description }}</p>
            <p class="my-3">${{ product.price.toFixed(2) }} / {{ product.size }}</p>
            <p v-if="product.special_order" class="leading-tight text-xs italic font-bold">SPECIAL ORDER 2 DAYS LEAD TIME</p>
        </div>

        <add-to-cart
            v-if="isCustomer"
            :product="product"
            class="mt-3"
            @openSpecialOrderItemModal="openSpecialOrderItemModal()"
        />
    </div>

    <product-quickview
        :product="quickviewProduct"
        :show="showQuickview"
        @close="showQuickview = false"
    ></product-quickview>

    <jet-dialog-modal :show="showSpecialOrderItemModal" :closeable="true">
        <template #title>
            Special Order Item
        </template>

        <template #content>
            You've added a special order item to your cart. Please note this item will arrive 2 shipping days after todays date.
        </template>

        <template #footer>
            <jet-tertiary-button @click="showSpecialOrderItemModal = false">
                Close
            </jet-tertiary-button>
        </template>
    </jet-dialog-modal>
</template>

<script>
import { usePage } from '@inertiajs/inertia-vue3'
import UseUserAuth from '@/Composables/UseUserAuth';
import AddToCart from '@/Pages/Catalogue/Partials/AddToCart';
import Ribbon from "@/Components/Ribbon";
import ProductQuickview from '@/Pages/Catalogue/Partials/ProductQuickview';
import JetDialogModal from '@/Jetstream/DialogModal';
import JetTertiaryButton from '@/Jetstream/TertiaryButton';

export default {
    setup () {
        const { isCustomer } = UseUserAuth(usePage().props.value.user);

        return {
            isCustomer,
        }
    },

    data () {
        return {
            quickviewProduct: null,
            showQuickview: false,
            showSpecialOrderItemModal: false,
        }
    },

    components: {
        Ribbon,
        AddToCart,
        ProductQuickview,
        JetDialogModal,
        JetTertiaryButton,
    },

    methods: {
        handleQuickview (product) {
            this.quickviewProduct = product;
            this.showQuickview = true;
        },

        openSpecialOrderItemModal () {
            if (!this.showQuickview)
            {
                this.showSpecialOrderItemModal = true;
            }
        }
    },

    props: ['product'],
}
</script>

<style>

    .product-image:hover img {
        opacity: 0.5;
    }

    .product-image:hover .overlay {
        display: block;
    }

    .overlay {
        display: none;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        padding: 3.95rem 0;
        font-weight: bold;
        text-shadow: 0px 1px 3px #FFF;
        color: #555;
        z-index: 8;
    }

</style>
